<common-modal
  *ngIf="isOpen"
  [isOpen]="isOpen"
  (isOpenChange)="isOpenChange.emit($event)"
  position="center"
>
  <ng-container header>
    <h2>{{ 'terms.modal.title' | translate }}</h2>
  </ng-container>
  <ng-container body>
    <div class="alert-info relative">
      <ng-icon
        name="hero-information-circle-mini"
        size="24"
        class="text-gray-light"
      ></ng-icon>
      <div class="flex flex-col flex-1 text-center">
        <span>{{ 'terms.modal.info' | translate }}</span>
      </div>
    </div>
    <div>
      <span>{{ 'terms.modal.message' | translate }}:</span>
      <div class="mt-2 border-2 border-gray-800 rounded radius p-2 bg-gray-900">
        <span
          [innerHtml]="getTermsSignMessage()"
          class="text-sm whitespace-pre-line"
        ></span>
      </div>
    </div>
  </ng-container>
</common-modal>
